/**
 * @fileoverview Base class for all pages in the SPA.
 * Each page owns its root DOM element and is responsible for its own rendering.
 */

import { render, type ComponentChild } from 'preact';

export abstract class BasePage {
    protected readonly el: HTMLElement;

    constructor(elementId: string) {
        const el = document.getElementById(elementId);
        if (!el) throw new Error(`Page element not found: #${elementId}`);
        this.el = el;
    }

    /** Show this page, hiding all sibling pages. */
    mount(params?: Record<string, string> | null): void {
        const allPages = ['container', 'faqPage', 'storyListPage', 'storyViewerPage'];
        for (const id of allPages) {
            const el = document.getElementById(id);
            if (el) el.classList.add('hidden');
        }
        this.el.classList.remove('hidden');
        void this.render(params ?? null);
    }

    /** Override to populate page content when navigated to. */
    protected async render(_params?: Record<string, string> | null): Promise<void> {}

    /** Render a Preact component tree into this page's root element. */
    protected renderPreact(vnode: ComponentChild): void {
        render(vnode, this.el);
    }

    /** Programmatically navigate to a path using the router. */
    protected navigate(path: string): void {
        (window as any).__appNavigate?.(path);
    }
}
